import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const pendo = defineConnector({
  identifier: "pendo",
  name: "Pendo",
  tagLine: "Product analytics and guidance",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: () => "https://app\\.pendo\\.io/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "x-pendo-integration-key",
        value: app.secret.apiKey,
      },
    ]),
  steps: [
    {
      title: "Find your Pendo API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "In your [Pendo](https://app.pendo.io/) account, go to **Settings > Integrations > Integration Keys**. Click **Add Integration Key** and copy the generated key.",
        },
      ],
    },
    {
      title: "Enter your API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Enter the API credentials from your Pendo account settings.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
          helperText: "The API key for your Pendo account",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://app.pendo.io/api/v1/page",
  },
});
